// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__12HIB","imageUploader":"EGiftCard_imageUploader__213mG"};